/**
 * Cliente API de tenencias para frontend-superadmin (Sprint 13 S13-13).
 *
 * El listado y cierre fueron migrados al portal en S13-05/07.
 * Esta superficie de sa cubre la CREACION de tenencias durante la
 * carga inicial del barrio. Lista usando require_super_admin_o_lectura_barrio.
 */
import { apiFetch } from './client';
import type {
  ListTenenciasFiltros,
  TenenciaConPersonaLote,
  TenenciaCreadaResponse,
  TenenciaCreate,
} from './types';

export function listTenencias(
  filtros: ListTenenciasFiltros = {},
): Promise<TenenciaConPersonaLote[]> {
  const params = new URLSearchParams();
  if (filtros.lote_id) params.set('lote_id', filtros.lote_id);
  if (filtros.persona_id) params.set('persona_id', filtros.persona_id);
  if (filtros.activas !== undefined)
    params.set('activas', String(filtros.activas));
  if (filtros.sector) params.set('sector', filtros.sector);
  const qs = params.toString();
  return apiFetch<TenenciaConPersonaLote[]>(
    `/tenencias/${qs ? `?${qs}` : ''}`,
  );
}

export function crearTenencia(
  data: TenenciaCreate,
): Promise<TenenciaCreadaResponse> {
  return apiFetch<TenenciaCreadaResponse>('/tenencias/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

// Sprint 13 S13-19: import CSV de tenencias.
export interface ImportTenenciasCsvResultado {
  total_filas: number;
  creados: number;
  rol_vecino_otorgados: number;
  errores: { fila: number; error: string }[];
}

export function importTenenciasCsv(
  archivo: File,
): Promise<ImportTenenciasCsvResultado> {
  const form = new FormData();
  form.append('archivo', archivo);
  return apiFetch<ImportTenenciasCsvResultado>('/tenencias/import-csv', {
    method: 'POST',
    body: form,
  });
}

// Sprint 13 S13-19: PATCH y DELETE de tenencias.
// S13-21: lote_id editable (caso "asocie a la casa equivocada").
export interface TenenciaUpdate {
  lote_id?: string;
  tipo?: string;
  desde?: string;
  responsable_pago_cuotas?: boolean;
  responsable_desde_periodo?: string | null;
  acceso_portal_habilitado?: boolean;
  notificar_morosidad?: boolean;
  doc_respaldo_url?: string | null;
  notas?: string | null;
}

export function actualizarTenencia(
  tenenciaId: string,
  data: TenenciaUpdate,
): Promise<unknown> {
  return apiFetch<unknown>(`/tenencias/${tenenciaId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export function eliminarTenencia(tenenciaId: string): Promise<void> {
  return apiFetch<void>(`/tenencias/${tenenciaId}`, { method: 'DELETE' });
}
